export default __webpack_public_path__ + "static/media/metaMask.84b7d9ae.svg";